import { request } from '../api';

export interface AuditRow {
  id: string;
  timestamp: string;
  actorId: string | null;
  actorDisplayName: string | null;
  action: string;
  resourceType: string;
  resourceId: string;
  channel: string | null;
  before: unknown;
  after: unknown;
}

export interface AuditListParams {
  actorId?: string;
  resourceType?: string;
  action?: string;
  from?: string;
  to?: string;
  page?: number;
  pageSize?: number;
}

export interface AuditListResult {
  rows: AuditRow[];
  total: number;
}

export interface AuditActorOption {
  actorId: string | null;
  displayName: string | null;
}

/** Mirrors `SYSTEM_ACTOR_QUERY_VALUE` in `apps/api/src/audit/audit.controller.ts` — send this back
 *  as `actorId` to filter for the `{ actorId: null }` "система" option from `auditApi.actors()`. */
export const SYSTEM_ACTOR_QUERY_VALUE = '__system__';

function query(params: AuditListParams): string {
  const q = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== '') q.set(key, String(value));
  }
  const s = q.toString();
  return s ? `?${s}` : '';
}

/** Audit block's own API surface; see `apps/web/src/api.ts` for `request`/`post`. */
export const auditApi = {
  list: (params: AuditListParams) => request<AuditListResult>(`/audit${query(params)}`),
  resourceTypes: () => request<string[]>('/audit/resource-types'),
  actors: () => request<AuditActorOption[]>('/audit/actors'),
};
